import * as yup from "yup";
import { MSG } from "../constants/MSG";

export const updateEmailTemplateSchema = yup.object().shape({
	email_subject: yup.string().trim().required(MSG.REQUIRED_SUBJECT),
	email_body: yup.string().trim().required(MSG.REQUIRED_DESCRIPTION),
	code: yup.string().trim().required(MSG.REQUIRED_EMAIL_KEY),
});
